import { render, staticRenderFns } from "./pemeriksaankesehatan.vue?vue&type=template&id=ac4a2d46&"
import script from "./pemeriksaankesehatan.vue?vue&type=script&lang=js&"
export * from "./pemeriksaankesehatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports